import React from 'react';
import { MathJaxContext, MathJax } from 'better-react-mathjax';
import './ViewAnswers.css';

const ViewAnswers = ({ questions, selectedAnswers }) => {
  return (
    <MathJaxContext>
      <div className="view-answers-section">
        <h3 className="view-title">📘 Review Your Answers</h3>

        {questions?.map((q, idx) => {
          // Student answer can be string (single) or array (multiple)
          const studentAnswer = selectedAnswers[idx] || (q.type === 'multiple' ? [] : '');
          // Correct options are letters (A, B, C, D)
          const correctLetters = q.correct_option_array || (q.type === 'single' ? [q.correct_option] : []);

          return (
            <div key={idx} className="answer-card">
              <div className="question">
                <strong>Q{idx + 1}:</strong>{' '}
                <MathJax>
                  <span dangerouslySetInnerHTML={{ __html: q.question }} />
                </MathJax>
              </div>

              <div className="options">
                {q.options.map((opt, i) => {
                  const letter = String.fromCharCode(65 + i); // A, B, C, D

                  // Check if this option was selected by student
                  const isSelected =
                    q.type === 'single'
                      ? studentAnswer === letter
                      : Array.isArray(studentAnswer)
                      ? studentAnswer.includes(letter)
                      : false;

                  // Check if this option is correct
                  const isCorrect = correctLetters.includes(letter);

                  let className = 'option-item';
                  if (isSelected && isCorrect) className += ' correct';
                  else if (isSelected && !isCorrect) className += ' incorrect';
                  else if (!isSelected && isCorrect) className += ' actual-correct';

                  return (
                    <div key={i} className={className}>
                      <MathJax>
                        <span>
                          <strong>{letter}.</strong>{' '}
                          <span dangerouslySetInnerHTML={{ __html: opt }} />
                        </span>
                      </MathJax>
                    </div>
                  );
                })}
              </div>

              {(studentAnswer.length === 0 || studentAnswer === '') && (
                <div className="not-attempted">❗ Not Attempted</div>
              )}
            </div>
          );
        })}
      </div>
    </MathJaxContext>
  );
};

export default ViewAnswers;
